import httpRequest from "../network/http";


//获取地区列表
export function getAreaAll(option) {
  return httpRequest({
    url: '/sys/screen/getAreaAll',
    method: 'post',
    data: option
  })
}

//获取（今日、本月）会员新增人数
export function getUserNewCount(option) {
  return httpRequest({
    url: '/sys/screen/getUserNewCount',
    method: 'post',
    data: option
  })
}

//获取当前区域下的合伙人数量
export function getPartnerCount(option) {
  return httpRequest({
    url: '/sys/screen/getPartnerCount',
    method: 'post',
    data: option
  })
}

//今日 （现金、积分）交易额
export function getTodayTradeVolume(option) {
  return httpRequest({
    url: '/sys/screen/getTodayTradeVolume',
    method: 'post',
    data: option
  })
}

//获取推荐的城市ID
export function getRecCityIdList(option) {
  return httpRequest({
    url: '/sys/screen/getRecCityIdList',
    method: 'post',
    data: option
  })
}

//获取区县列表统计
export function getCountyDetail(option) {
  return httpRequest({
    url: '/sys/screen/getCountyDetail',
    method: 'post',
    data: option
  })
}

//获取城市合伙人人数统计
export function getPartnerAreaInfo(option) {
  return httpRequest({
    url: '/sys/partner/getPartnerAreaInfo',
    method: 'get',
    params: option
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js